import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

const rocheSearchInputCss = "roche-search-input{position:relative;display:block}@media (min-width: 48rem){roche-search-input{width:66.6666666667%;margin-top:3rem}}roche-search-input input{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;appearance:none;box-sizing:border-box;font-family:\"roche-sans\";font-weight:200;background-color:transparent;border:none;border-bottom:1px solid #706b69;border-radius:0;padding:0.3125rem 1.875rem 0.75rem 2.5rem;width:100%}@media (min-width: 64rem){roche-search-input input{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}@media (min-width: 48rem){roche-search-input input{font-size:1.5625rem;line-height:2.1875rem}}roche-search-input input:active,roche-search-input input:hover,roche-search-input input:focus{border-bottom-color:#0b41cd}roche-search-input input::placeholder{color:#706b69;margin-right:0.625rem}roche-search-input input:focus{outline:none}roche-search-input input::-webkit-search-decoration,roche-search-input input::-webkit-search-cancel-button,roche-search-input input::-webkit-search-results-button,roche-search-input input::-webkit-search-results-decoration{appearance:none}roche-search-input roche-icon{fill:#706b69;position:absolute;top:0.4375rem;left:0}@media (min-width: 48rem){roche-search-input roche-icon{top:0.6875rem}}roche-search-input roche-icon[icon=remove]{position:absolute;left:auto;right:0.1875rem}roche-search-input roche-icon[icon=remove]:hover{cursor:pointer}roche-search-input[dir=rtl] input{padding-left:1.875rem;padding-right:2.5rem}roche-search-input[dir=rtl] roche-icon{left:auto;right:0.1875rem}roche-search-input[dir=rtl] roche-icon[icon=remove]{left:0;right:auto}";
const RocheSearchInputStyle0 = rocheSearchInputCss;

const RocheSearchInput$1 = /*@__PURE__*/ proxyCustomElement(class RocheSearchInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    render() {
        return (h(Host, { key: '4eee677fc7240eb51b89eb7dc53af5c5843f6a41' }, h("roche-icon", { key: 'd6b824a4248ea4061d50f079aaa0f3a5a6ff5796', icon: "search", height: "1.5rem" }), h("slot", { key: '269e982d574bf9d1c56d4d1492a7d8210df74c10' })));
    }
    get element() { return this; }
    static get style() { return RocheSearchInputStyle0; }
}, [4, "roche-search-input"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-search-input", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-search-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheSearchInput$1);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheSearchInput = RocheSearchInput$1;
const defineCustomElement = defineCustomElement$1;

export { RocheSearchInput, defineCustomElement };

//# sourceMappingURL=roche-search-input.js.map